(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["currency-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bucks-currency-selector')) {
    const instances = new Set();
    const widgetSelector = '.buckscc-currency-wrapper';
    let nextId = 0;
    let updateFrame;

    function getBucksState() {
      const app = window.bucksCC;
      const config = app?.metaConfig;
      if (!config?.active || config.multiCurrencyEnabled || config.marketStatus || config.cartCurrency !== 'USD') return null;

      let currencies = config.selectedCurrencies;
      if (typeof currencies === 'string') {
        try {
          currencies = JSON.parse(currencies);
        } catch {
          return null;
        }
      }
      if (!Array.isArray(currencies) || !currencies.length) return null;

      const codes = currencies.map((currency) => Object.keys(currency || {})[0]);
      if (codes.some((code) => !/^[A-Z]{3}$/.test(code)) || new Set(codes).size !== codes.length) return null;

      const triggers = Array.from(document.querySelectorAll(`${widgetSelector} .buckscc-select-options .converterTriggers`));
      if (!codes.every((code) => triggers.some((trigger) => trigger.id === code))) return null;

      const selected = document.querySelector(`${widgetSelector} .bucks-selected`)?.textContent.trim();
      if (!codes.includes(selected)) return null;

      return {codes, selected, triggers};
    }

    function syncSelectors() {
      const state = getBucksState();
      instances.forEach((instance) => instance.update(state));
      document.documentElement.classList.toggle('bucks-currency-selector-ready', Boolean(state && instances.size));
    }

    function scheduleSync() {
      if (updateFrame) return;
      updateFrame = requestAnimationFrame(() => {
        updateFrame = null;
        syncSelectors();
      });
    }

    const observer = new MutationObserver((records) => {
      const widgetChanged = records.some((record) =>
        record.target.closest?.(widgetSelector) ||
        [...record.addedNodes, ...record.removedNodes].some((node) =>
          node.nodeType === 1 && (node.matches(widgetSelector) || node.querySelector(widgetSelector))
        )
      );
      if (widgetChanged) scheduleSync();
    });

    class BucksCurrencySelector extends HTMLElement {
      connectedCallback() {
        this.select = this.querySelector('select');
        const description = this.querySelector('[data-currency-description]');
        description.id = `display-currency-description-${++nextId}`;
        this.select.setAttribute('aria-describedby', description.id);
        this.onChange = () => {
          const state = getBucksState();
          const trigger = state?.triggers.find((option) => option.id === this.select.value);
          if (trigger) trigger.click();
          syncSelectors();
        };
        this.select.addEventListener('change', this.onChange);
        instances.add(this);
        if (instances.size === 1) observer.observe(document.body, {childList: true, subtree: true});
        syncSelectors();
      }

      disconnectedCallback() {
        this.select.removeEventListener('change', this.onChange);
        instances.delete(this);
        if (!instances.size) observer.disconnect();
        syncSelectors();
      }

      update(state) {
        const codes = state?.codes || [this.dataset.baseCurrency];
        const signature = codes.join(',');
        if (signature !== this.signature) {
          this.select.replaceChildren(...codes.map((code) => new Option(code, code)));
          this.signature = signature;
        }
        this.select.value = state?.selected || this.dataset.baseCurrency;
        this.select.disabled = !state;
      }
    }

    window.addEventListener('BUCKSCC-LOADED', scheduleSync);
    document.addEventListener('BUCKS_SELECTED_CURRENCY', scheduleSync);
    customElements.define('bucks-currency-selector', BucksCurrencySelector);
  }
  } catch(e) { console.error(e); }
})();

})();
